<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { onBeforeUnmount } from 'vue';

  import AsideData from '@/components/Dashboard/AsideData.vue';
  import CallAnalytics from '@/components/Dashboard/CallAnalytics.vue';
  import DashboardSubHeader from '@/components/Dashboard/DashboardSubHeader.vue';
  import TotalsSummaryRow from '@/components/Dashboard/TotalsSummaryRow.vue';
  import SummaryTables from '@/components/LivePanel/SummaryTables/SummaryTables.vue';
  import { useDashboardStore } from '@/stores/reports/dashboard.store';
  import { livePanelStore } from '@/stores/socket/live-panel-socket.store';

  const dashboardStore = useDashboardStore();
  const liveStore = livePanelStore();

  const { isLoading } = storeToRefs(dashboardStore);
  const { getDashboardData } = dashboardStore;
  const { startDashboardReactive, stopReactive } = liveStore;

  getDashboardData();
  startDashboardReactive();

  onBeforeUnmount(() => {
    stopReactive();
  });
</script>

<template>
  <section class="flex min-h-full flex-col p-0">
    <bv-app-logo
      v-if="isLoading"
      class="flex-1"
      loading
    />
    <section
      v-else
      class="relative flex flex-col bg-neutral-50 px-4 py-6 md:p-0"
    >
      <dashboard-sub-header />

      <totals-summary-row class="flex-0" />
      <v-row class="flex-0">
        <call-analytics />

        <aside-data />
      </v-row>

      <summary-tables class="mt-5 flex-1" />
    </section>
  </section>
</template>
